import React, { useEffect, useState, useMemo } from 'react';
import moment from 'moment';
import {useRecoilState} from "recoil";
import mainStore from "src/stores/main";

interface IProps {
  onFinish: () => void,
  duration: number,
}
function Timer({ onFinish, duration }: IProps) {
  const [milliseconds, setMilliseconds] = useState(duration * 1000);

  const [minutes, seconds] = useMemo(() => {
    const remainderDuration = moment.duration(milliseconds);
    return [remainderDuration.minutes(), remainderDuration.seconds() + Math.round(remainderDuration.milliseconds() / 1000)];
  }, [milliseconds, setMilliseconds]);

  useEffect(() => {
    const start = Date.now();
    const timer = setTimeout(() => {
      if (milliseconds <= 0) onFinish();
      else {
        const diff = Date.now() - start;
        setMilliseconds(milliseconds - diff);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [milliseconds, setMilliseconds]);

  return (
    <p className="timer-count">{`${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`}</p>
  );
}

export default Timer;
